import React, { useState } from 'react';
import { Copy } from 'lucide-react';
import { Button } from '@/Components/shadcn';
import UIStrings from '@/Utils/UIStrings';

function CopyToClipboard(): React.JSX.Element {
    const { protocol, host } = window.location;
    const url = `${protocol}//${host}`;
    const [copied, setCopied] = useState(false);

    const copyHandler = async () => {
        await navigator.clipboard.writeText(url);
        setCopied(true);
        window.setTimeout(() => setCopied(false), 5000);
    };

    return (
        <div className="flex flex-col gap-2">
            <div className="border-border bg-muted/60 flex flex-col items-stretch justify-between gap-3 rounded-xl border p-3 sm:flex-row sm:items-center">
                <span className="text-foreground font-mono text-sm font-medium break-all sm:text-base">{url}</span>
                <Button
                    type="button"
                    variant="secondary"
                    className="h-10 shrink-0 gap-2 rounded-xl px-4"
                    onClick={copyHandler}
                >
                    <Copy className="h-4 w-4" aria-hidden />
                    {UIStrings.CopyToClipboard}
                </Button>
            </div>
            {copied ? (
                <p className="text-sm font-medium text-emerald-600 dark:text-emerald-400" role="status">
                    {UIStrings.LinkCopied}
                </p>
            ) : null}
        </div>
    );
}

export default CopyToClipboard;
